import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6b014e66")

_pushScopeId("data-v-6b014e66")
const _hoisted_1 = { class: "r-grid container" }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Shared Calendars Assignment: ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_5 = {
  key: 0,
  class: "r-grid container"
}
const _hoisted_6 = { class: "leave-balance-link" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" View Detailed Leave Balance ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_accordion_title = _resolveComponent("accordion-title")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.userInfoData)
    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_accordion_title, {
            title: _ctx.userInfoData.name,
            toggle: _ctx.userToggle,
            "onUpdate:toggle": _cache[1] || (_cache[1] = ($event: any) => (_ctx.userToggle = $event)),
            onUpdateToggle: _cache[2] || (_cache[2] = ($event: any) => (_ctx.userToggle = $event))
          }, null, 8, ["title", "toggle"]),
          _withDirectives(_createVNode("p", null, "Title: " + _toDisplayString(_ctx.userInfoData.title), 513), [
            [_vShow, _ctx.userToggle]
          ]),
          _withDirectives(_createVNode("p", null, "Unit: " + _toDisplayString(_ctx.userInfoData.unit), 513), [
            [_vShow, _ctx.userToggle]
          ]),
          (_ctx.userInfoData.isEmployee)
            ? _withDirectives((_openBlock(), _createBlock("p", { key: 0 }, " Supervisor: " + _toDisplayString(_ctx.userInfoData.supervisor_name), 513)), [
                [_vShow, _ctx.userToggle]
              ])
            : _createCommentVNode("", true),
          (_ctx.userInfoData.isEmployee && _ctx.userInfoData.alt_supervisor_name)
            ? _withDirectives((_openBlock(), _createBlock("p", { key: 1 }, "Alt Supervisor: " + _toDisplayString(_ctx.userInfoData.alt_supervisor_name), 513)), [
                [_vShow, _ctx.userToggle]
              ])
            : _createCommentVNode("", true),
          (
          _ctx.userInfoData.isEmployee
          && _ctx.userCalendarsData
          && _ctx.userCalendarsData.length > 0
        )
            ? _withDirectives((_openBlock(), _createBlock("p", _hoisted_2, [
                _hoisted_3,
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userCalendarsData, (calendar, index) => {
                  return (_openBlock(), _createBlock("span", { key: index }, [
                    _createTextVNode(_toDisplayString(calendar) + " ", 1),
                    (
              _ctx.userCalendarsData.length > 1
              && (index != _ctx.userCalendarsData.length - 1)
            )
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _hoisted_4
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ], 512)), [
                [_vShow, _ctx.userToggle]
              ])
            : _createCommentVNode("", true)
        ]),
        (_ctx.userInfoData.isEmployee
      || (!_ctx.userInfoData.isEmployee
      && _ctx.$route.name === 'View/Edit User'
      && _ctx.$store.state.userInfoData.isHRAdmin))
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode(_component_accordion_title, {
                title: "Leave Balance",
                toggle: _ctx.balanceToggle,
                "onUpdate:toggle": _cache[3] || (_cache[3] = ($event: any) => (_ctx.balanceToggle = $event)),
                onUpdateToggle: _cache[4] || (_cache[4] = ($event: any) => (_ctx.balanceToggle = $event))
              }, null, 8, ["toggle"]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userInfoData.leaveBalance, (leave, index) => {
                return _withDirectives((_openBlock(), _createBlock("p", { key: index }, _toDisplayString(leave.name) + ": " + _toDisplayString(leave.balance) + " " + _toDisplayString(_ctx.userInfoData.leaves_value_type), 513)), [
                  [_vShow, _ctx.balanceToggle]
                ])
              }), 128)),
              _withDirectives(_createVNode("p", _hoisted_6, [
                _createVNode(_component_router_link, {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.ifHRAdminLink())),
                  to: _ctx.leaveBalanceLink()
                }, {
                  default: _withId(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["to"])
              ], 512), [
                [_vShow, _ctx.balanceToggle]
              ])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    : _createCommentVNode("", true)
})